import { IonBackButton, IonButton, IonButtons, IonCheckbox, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToast, IonToolbar, useIonAlert } from '@ionic/react';
import { arrowBack, openOutline } from 'ionicons/icons';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { requestService, usuarioCadastrar } from '../../../Utils/Services';
import { useGooglePlacesSimple } from '../../../components/useGooglePlacesSimple';
import RoletaDescontos from '../RoletaDescontos/RoletaDescontos';
import './CadastroCnpj.css';

const specialties = {
  // 'Assistência Técnica': ['Celular', 'Computador', 'Televisão', 'Ar condicionado', 'Lava roupa', 'Geladeira e freezer', 'Micro-ondas', 'Lava Louças', 'Maquina de costura'],
  // 'Reformas e Reparos': ['Aluguel de Maquinário', 'Arquiteto', 'Automação Residencial', 'Azulejista', 'Banheira', 'Casas e Chalés de Madeira', 'Chaveiro', 'Climatização', 'Coifas e Exaustores', 'Concretagem', 'Decorador', 'Dedetizador', 'Demolição', 'Desentupidor', 'Design de Interiores', 'Desinfecção', 'Diarista', 'Dutos', 'Eletricista', 'Empreiteiro', 'Encanador', 'Energia Solar', 'Engenheiro', 'Escada, Corrimão e Guarda-Corpo', 'Escavação', 'Fossa', 'Galvanização', 'Gesso e DryWall', 'Gás', 'Impermeabilizador', 'Instalador TV Digital', 'Instalação de eletrônicos', 'Instalação de Papel de Parede', 'Isolamentos Térmico e Acústico', 'Jardinagem', 'Lareira', 'Lazer e Recreação', 'Limpeza Pós Obra', 'Marceneiro', 'Marido de aluguel', 'Marmoraria e Granitos', 'Montador de Móveis', 'Mudanças e Carretos', 'Paisagista', 'Pavimentação', 'Pedreiro', 'Pintor', 'Piscina', 'Portão Automático', 'Poço Artesiano', 'Prevenção e Combate a Incêndio', 'Reciclagem', 'Redes de Proteção', 'Remoção de Entulho', 'Restauração e Polimento de Pisos', 'Sauna', 'Segurança Eletrônica', 'Segurança Perimetral', 'Serralheria e Solda', 'Sonorização de Ambientes', 'Tapeceiro', 'Terraplanagem', 'Toldos e Coberturas', 'Topografia', 'Vidraceiro'],
  // 'Serviços Domésticos': ['Diarista', 'Mensalista', 'Passadeira', 'Cozinheira', 'Babá', 'Pet Sitter', 'Motorista'],
  // 'Festas': ['Buffet', 'Salgados', 'Garçom', 'Bartender', 'Confeitaria', 'Música', 'Animação'],
  'Restaurantes': ['Pizzaria', 'Hamburgueria', 'Lanches', 'Salgados', 'Porções', 'Brasileiro', 'Italiano', 'Japonês', 'Chinês', 'Carnes', 'Frutos do Mar', 'Mediterrâneo', 'Mexicano', 'Vegetariano', 'Sorveteria', 'Confeitaria'],
  // 'Saúde': ['Personal Trainer', 'Cuidador de Pessoas', 'Enfermeira', 'Psicólogo', 'Nutricionista', 'Fisioterapeuta'],
  // 'Estética': ['Cabeleireiro', 'Manicure', 'Pedicure', 'Especialista em depilação', 'Esteticista', 'Designer de sobrancelhas', 'Maquiadora', 'Barbeiro']
};

const segments = [
  // 'Atendimentos',
  // 'Obras',
  // 'OS',
  'Pedidos',
  // 'Projetos',
  // 'Prontuários',
  // 'Vendas'
];

const CadastroCnpj: React.FC = () => {

  const validator = require('validator');
  const TAB_KEY_CODE = 9;
  const ENTER_KEY_CODE = 13;
  const history = useHistory();
  const campoTelefone = useRef<any>(null);
  const campoTelefoneComercial = useRef<any>(null);

  const [nomeComercial, setNomeComercial] = useState("");
  const [empresaCNPJ, setEmpresaCNPJ] = useState("");
  const [telefoneComercial, setTelefoneComercial] = useState("");
  const [emailComercial, setEmailComercial] = useState("");
  const [endereco, setEndereco] = useState("");
  const [enderecoLat, setEnderecoLat] = useState("");
  const [enderecoLng, setEnderecoLng] = useState("");
  const [ignorarProximaMudanca, setIgnorarProximaMudanca] = useState(false);

  const [nome, setNome] = useState("");
  const [cpf, setCPF] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  // const [dataAniversario, setDataAniversario] = useState("");
  // const [dataAniversarioBr, setDataAniversarioBr] = useState("");
  // const [showModalDataCad, setShowModalDataCad] = useState(false);
  // const popover1 = useRef<HTMLIonPopoverElement>(null);
  const [convite, setConvite] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [checked, setChecked] = useState(false);
  const [showLoading, setShowLoading] = useState(false);


  // const openPopoverCad = (e: any) => {
  //   popover1.current!.event = e;
  //   setShowModalDataCad(true);
  // };



  const [selectedSegment, setSelectedSegment] = useState<string>('');
  const [selectedArea, setSelectedArea] = useState<string>('');
  const [selectedSpecialties, setSelectedSpecialties] = useState<string[]>([]);

  const [mostartAlerta] = useIonAlert();
  const [localEnderecoSelecionado, setLocalEnderecoSelecionado] = useState<any>("");
  const [listaEnderecos, setListaEnderecos] = useState<any>([]);

  const [showRouletteModal, setShowRouletteModal] = useState(false);
  const [roletaResultado, setRoletaResultado] = useState<string>("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const conviteParam = urlParams.get('convite') || "";
    setConvite(conviteParam);

    // Verifica se já utilizou a roleta
    const roletaJaUtilizada = localStorage.getItem('xeguei_roleta_utilizada');
    const resultadoSalvo = localStorage.getItem('xeguei_roleta_resultado');

    if (!conviteParam && roletaJaUtilizada !== 'true') {
      // Só mostra a roleta se não tem convite E ainda não utilizou a roleta
      setTimeout(() => setShowRouletteModal(true), 200);
    } else if (roletaJaUtilizada === 'true' && resultadoSalvo) {
      // Se já utilizou, define o resultado automaticamente
      setRoletaResultado(resultadoSalvo);
      const desconto = resultadoSalvo.replace('%', '');
      setConvite(`ROLETA${desconto}`);
    }
  }, []);

  // Hook do Google Places Simple
  const {
    listaEnderecos: listaEnderecosGoogle,
    buscandoEndereco: loadingEnderecos,
    buscarSugestoes: buscarSugestoesEndereco,
    buscarDetalhes: buscarDetalhesEndereco,
    limparSugestoes: limparSugestoesEndereco
  } = useGooglePlacesSimple({
    onError: (mensagem: string) => {
      setTextToast(mensagem);
      setShowToast(true);
    },
    onLoading: setShowLoading
  });

  // Função para buscar detalhes e preencher campos automaticamente
  const handleBuscarDetalhesEndereco = useCallback(async (placeId: string, enderecoFormatado: string) => {
    try {
      const detalhes = await buscarDetalhesEndereco(placeId, enderecoFormatado);
      if (detalhes && detalhes.sucesso) {
        setEndereco(detalhes.endereco);
        setEnderecoLat(detalhes.latitude.toString());
        setEnderecoLng(detalhes.longitude.toString());

        // Limpar sugestões após seleção
        limparSugestoesEndereco();
      }
    } catch (error) {
      console.error('Erro ao buscar detalhes do endereço:', error);
    }
  }, [buscarDetalhesEndereco, limparSugestoesEndereco]);

  // Função para lidar com seleção de item da lista de sugestões
  const handleSelectItemEndereco = useCallback((item: any) => {
    // Ativa flag para ignorar próxima mudança (evita busca automática)
    setIgnorarProximaMudanca(true);

    // Busca detalhes completos do endereço selecionado
    handleBuscarDetalhesEndereco(item.placeId, item.descricao);
  }, [handleBuscarDetalhesEndereco]);

  const handleSegmentChange = (e: CustomEvent) => {
    setSelectedSegment(e.detail.value);
  };

  const handleAreaChange = (e: CustomEvent) => {
    setSelectedArea(e.detail.value);
    setSelectedSpecialties([]);
  };

  const handleSpecialtyChange = (specialty: string) => {
    setSelectedSpecialties((prevSelectedSpecialties) => {
      if (prevSelectedSpecialties.includes(specialty)) {
        return prevSelectedSpecialties.filter((item) => item !== specialty);
      } else {
        return [...prevSelectedSpecialties, specialty];
      }
    });
  };

  const validarCampos = () => {

    if (!nomeComercial) {
      setTextToast('O campo nome comercial é obrigatório.');
      setShowToast(true);
      return false;
    }

    if (!empresaCNPJ) {
      setTextToast('O campo CNPJ é obrigatório.');
      setShowToast(true);
      return false;
    }

    if (!telefoneComercial) {
      setTextToast('O campo telefone comercial é obrigatório.');
      setShowToast(true);
      return false;
    }


    if (!emailComercial) {
      setTextToast('O campo e-mail comercial é obrigatório.');
      setShowToast(true);
      return false;
    }

    if (!endereco) {
      setTextToast('O campo endereço comercial é obrigatório.');
      setShowToast(true);
      return false;
    }



    if (!nome) {
      setTextToast('O campo nome é obrigatório.');
      setShowToast(true);
      return false;
    }

    if (!cpf) {
      setTextToast('O campo CPF é obrigatório.');
      setShowToast(true);
      return false;
    }

    if (!telefone) {
      setTextToast('O campo telefone é obrigatório.');
      setShowToast(true);
      return false;
    }

    if (!email) {
      setTextToast('O campo e-mail é obrigatório.');
      setShowToast(true);
      return false;
    }


    // if (!dataAniversarioBr) {
    //   setTextToast('O campo data de aniversário é obrigatório.');
    //   setShowToast(true);
    //   return false;
    // }

    return true; // Se todos os campos forem válidos
  };

  const cadastrar = () => {

    let validadorCelular = /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/;



    if (validarCampos()) {

      if (!selectedSegment) {
        setTextToast("O campo trabalha é obrigatório.");
        setShowToast(true);
      }
      else if (!selectedArea) {
        setTextToast("O campo área é obrigatório.");
        setShowToast(true);
      }
      else if (selectedSpecialties.length == 0) {
        setTextToast("O campo especialidade é obrigatório.");
        setShowToast(true);
      }
      else if (selectedSpecialties.length > 3) {
        setTextToast("Selecione até 3 especialidades.");
        setShowToast(true);
      }
      else if (checked == false) {
        setTextToast("Você precisa aceitar os termos de uso e política de privacidade para efetuar o cadastro.");
        setShowToast(true);
      }
      else {


        if (!validarCnpjNovo(empresaCNPJ)) {
          setTextToast("CNPJ Inválido.");
          setShowToast(true);
        }
        else if (!validadorCelular.test(telefoneComercial)) {
          setTextToast("Celular Comercial Inválido.");
          setShowToast(true);
        }
        else if (!validator.isEmail(emailComercial)) {
          setTextToast("E-mail Comercial Inválido.");
          setShowToast(true);
        }
        /*
        else if (!validator.isMobilePhone(telefone, 'pt-BR')) {
          setTextToast("Celular Inválido.");
          setShowToast(true);
        }
        */
        else if (!validarCpfNovo(cpf)) {
          setTextToast("CPF Inválido.");
          setShowToast(true);
        }
        else if (!validadorCelular.test(telefone)) {
          setTextToast("Celular Inválido.");
          setShowToast(true);
        }
        else if (!validator.isEmail(email)) {
          setTextToast("E-mail Inválido.");
          setShowToast(true);
        }
        else {

          const objectRequest = {

            nomeComercialValue: nomeComercial,
            cnpjCpfValue: empresaCNPJ.replace(".", "").replace(".", "").replace("/", "").replace("-", ""),
            enderecoCompletoValue: endereco,
            enderecoLat: enderecoLat,
            enderecoLng: enderecoLng,
            whatsappValue: "55" + telefoneComercial.replace("(", "").replace(")", "").replace(" ", "").replace("-", ""),
            emailValue: emailComercial,
            trabalhoValue: selectedSegment,

            nomeValue: nome,
            cpfLoginValue: cpf.replace("-", "").replace(".", "").replace(".", ""),
            celularLoginValue: "55" + telefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", ""),
            emailLoginValue: email,
            areaValue: selectedArea,
            especialidadeValue: selectedSpecialties,

            cupomValue: convite
          }

          setShowLoading(true);
          requestService(
            usuarioCadastrar.url.replace("{id}", cpf.replace("-", "").replace(".", "").replace(".", "")),
            {
              method: usuarioCadastrar.method,
              body: JSON.stringify(objectRequest),
              credentials: 'include'
            },
            history,
            (response: any) => {
              console.log(response);
              if (response) {
                window.localStorage.setItem("cpf", cpf.replace("-", "").replace(".", "").replace(".", ""));
                window.localStorage.setItem("telefone", "55" + telefone.replace(/\(/g, "").replace(/\)/g, "").replace(/\ /g, "").replace(/\-/g, ""));
                window.localStorage.setItem("token", response.token);
                window.localStorage.setItem("perfil", response.perfil);

                // setTextToast(response.message);
                // setShowToast(true);
                setShowLoading(false);
                history.replace("/cadastro-sucesso");
              }
            },
            (error: any) => {
              console.log(error);
              setShowLoading(false);
              setTextToast(error?.message);
              setShowToast(true);
              if (error.data) {
                console.log("entrou varios endereços");
                if (Array.isArray(error.data) && error.data.length > 0) {
                  setListaEnderecos(error.data);
                }
              }
            }
          )
        }
      }
    }
  }

  function readListaEnderecos() {
    return listaEnderecos.map((value: any, index: any) => (
      <IonItem
        key={"endereco" + value.place_id}
        button
        onClick={() => setLocalEnderecoSelecionado(value.formatted_address)}
        color={localEnderecoSelecionado === value.formatted_address ? 'tertiary' : ''}
      >
        <IonLabel>{value.formatted_address}</IonLabel>
      </IonItem>
    ));
  }

  function onChangeCPF(e: any) {

    //console.log(cpf.length);
    //console.log(e.target.value.length);
    e.persist();
    e.preventDefault();

    // if (e.keyCode === ENTER_KEY_CODE || e.keyCode === TAB_KEY_CODE) {
    //   e.target.value = e.target.value.substring(0, 14);
    //   setCPF(e.target.value.substring(0, 14));
    //   campoTelefone.current.setFocus();
    // }

    if (e.target.value.length > 14) {
      e.target.value = e.target.value.substring(0, 14);
      setCPF(e.target.value.substring(0, 14));
      return;
    }

    let val = e.target.value;
    var cpfval = val.replace(/\D/g, "")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    console.log(cpfval);
    setCPF(cpfval);
  }

  function onInputTelefone(e: any) {
    // Remove todos os caracteres que não são números
    let apenasNumeros = e.target.value.replace(/[^\d]/g, '');

    // Limita a 11 dígitos (DDD + número)
    if (apenasNumeros.length > 11) {
      apenasNumeros = apenasNumeros.substring(0, 11);
    }

    // Se não há números, limpa o campo
    if (apenasNumeros.length === 0) {
      setTelefone('');
      return;
    }

    // Aplica a máscara
    let telefoneFormatado = '';

    if (apenasNumeros.length > 0) {
      telefoneFormatado = '(' + apenasNumeros.substring(0, Math.min(2, apenasNumeros.length));

      if (apenasNumeros.length >= 2) {
        telefoneFormatado += ') ';
      }

      if (apenasNumeros.length > 2) {
        telefoneFormatado += apenasNumeros.substring(2, Math.min(7, apenasNumeros.length));
      }

      if (apenasNumeros.length > 7) {
        telefoneFormatado += '-' + apenasNumeros.substring(7, 11);
      }
    }

    setTelefone(telefoneFormatado);
  }

  function onInputTelefoneComercial(e: any) {
    // Remove todos os caracteres que não são números
    let apenasNumeros = e.target.value.replace(/[^\d]/g, '');

    // Limita a 11 dígitos (DDD + número)
    if (apenasNumeros.length > 11) {
      apenasNumeros = apenasNumeros.substring(0, 11);
    }

    // Se não há números, limpa o campo
    if (apenasNumeros.length === 0) {
      setTelefoneComercial('');
      return;
    }

    // Aplica a máscara
    let telefoneFormatado = '';

    if (apenasNumeros.length > 0) {
      telefoneFormatado = '(' + apenasNumeros.substring(0, Math.min(2, apenasNumeros.length));

      if (apenasNumeros.length >= 2) {
        telefoneFormatado += ') ';
      }

      if (apenasNumeros.length > 2) {
        telefoneFormatado += apenasNumeros.substring(2, Math.min(7, apenasNumeros.length));
      }

      if (apenasNumeros.length > 7) {
        telefoneFormatado += '-' + apenasNumeros.substring(7, 11);
      }
    }

    setTelefoneComercial(telefoneFormatado);
  }

  function validarCpfNovo(val: any): boolean {
    if (val.length == 14) {
      var cpf = val.trim();

      cpf = cpf.replace(/\./g, '');
      cpf = cpf.replace('-', '');
      cpf = cpf.split('');

      var v1 = 0;
      var v2 = 0;
      var aux = false;

      for (var i = 1; cpf.length > i; i++) {
        if (cpf[i - 1] != cpf[i]) {
          aux = true;
        }
      }

      if (aux == false) {
        return false;
      }

      for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
        v1 += cpf[i] * p;
      }

      v1 = ((v1 * 10) % 11);

      if (v1 == 10) {
        v1 = 0;
      }

      if (v1 != cpf[9]) {
        return false;
      }

      for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
        v2 += cpf[i] * p;
      }

      v2 = ((v2 * 10) % 11);

      if (v2 == 10) {
        v2 = 0;
      }

      if (v2 != cpf[10]) {
        return false;
      } else {
        return true;
      }
    } else { return false; }
  }

  function validarCnpjNovo(val: any): boolean {
    if (val.length == 18) {
      let cnpj = val.trim();

      cnpj = cnpj.replace(/\./g, '');
      cnpj = cnpj.replace('-', '');
      cnpj = cnpj.replace('/', '');
      cnpj = cnpj.split('').map(Number);

      let v1 = 0;
      let v2 = 0;
      const multiplicador1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      const multiplicador2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

      // Verificação de sequência repetida
      let aux = cnpj.some((value: any, index: any, array: any) => value !== array[0]);
      if (!aux) {
        return false;
      }

      // Validação do primeiro dígito verificador
      for (let i = 0; i < 12; i++) {
        v1 += cnpj[i] * multiplicador1[i];
      }

      v1 = v1 % 11;
      v1 = v1 < 2 ? 0 : 11 - v1;

      if (v1 != cnpj[12]) {
        return false;
      }

      // Validação do segundo dígito verificador
      for (let i = 0; i < 13; i++) {
        v2 += cnpj[i] * multiplicador2[i];
      }

      v2 = v2 % 11;
      v2 = v2 < 2 ? 0 : 11 - v2;

      if (v2 != cnpj[13]) {
        return false;
      }

      return true;
    } else {
      return false;
    }
  }

  function onChangeCNPJ(e: any) {

    e.persist();
    e.preventDefault();

    if (e.keyCode === ENTER_KEY_CODE || e.keyCode === TAB_KEY_CODE) {
      e.target.value = e.target.value.substring(0, 18);
      setEmpresaCNPJ(e.target.value.substring(0, 18));
    }

    if (e.target.value.length > 18) {
      e.target.value = e.target.value.substring(0, 18);
      setEmpresaCNPJ(e.target.value.substring(0, 18));
      return;
    }

    let val = e.target.value;
    var cnpjval = val.replace(/\D+/g, '') // não deixa ser digitado nenhuma letra
      .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de número o primeiro com 2 digitos e o segundo de com 3 digitos, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2') // captura 2 grupos de número o primeiro e o segundo com 3 digitos, separados por /
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1'); // captura os dois últimos 2 números, com um - antes dos dois números

    setEmpresaCNPJ(cnpjval);

  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonBackButton icon={arrowBack} text=''></IonBackButton>
          </IonButtons>
          <IonTitle>Criar sua conta</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={"CadastroCnpj"}>
        <IonLabel className="titulo"><strong>Conta de Empresa</strong></IonLabel>

        <div className="input">
          <span><b>Dados da empresa</b></span>
        </div>
        <div className="input">
          <span>Nome Comercial*</span>
          <IonInput value={nomeComercial} autoCorrect='true' autoCapitalize='true' maxlength={50} placeholder="" onIonInput={(e: any) => setNomeComercial(e.target.value)}></IonInput>
        </div>
        <div className="input">
          <span>CNPJ*</span>
          <IonInput type="tel" maxlength={18} placeholder="__.___.___/____-__" required value={empresaCNPJ} onKeyUp={(e: any) => (onChangeCNPJ(e))} onIonInput={(e: any) => setEmpresaCNPJ(e.target.value)} />
        </div>
        <div className="input">
          <span>Celular Comercial*</span>
          <IonInput ref={(ref) => campoTelefoneComercial.current = ref} type="tel" maxlength={15} placeholder="(__) _____-____" required value={telefoneComercial} onIonInput={onInputTelefoneComercial} />
        </div>
        <div className="input">
          <span>E-mail Comercial*</span>
          <IonInput value={emailComercial} autoCorrect='true' maxlength={50} type="email" placeholder="" onIonInput={(e: any) => setEmailComercial(e.target.value)}></IonInput>
        </div>
        <div className="input">
          <span>Endereço Comercial*</span>
          <IonInput
            value={endereco}
            autoCorrect='true'
            autoCapitalize='true'
            maxlength={200}
            placeholder="Avenida Paulista, 111, São Paulo"
            onIonInput={(e: any) => {
              const valor = e.target.value || "";
              setEndereco(valor);

              // Se flag estiver ativa, ignorar busca (foi preenchimento automático)
              if (ignorarProximaMudanca) {
                setIgnorarProximaMudanca(false);
                return;
              }

              // Buscar sugestões automaticamente
              buscarSugestoesEndereco(valor);
            }}
            onKeyDown={(e: any) => {
              // Enter força busca imediata
              if (e.key === "Enter") {
                e.preventDefault();
                const valor = endereco || '';
                if (valor.trim().length >= 4) {
                  buscarSugestoesEndereco(valor, true);
                } else {
                  setTextToast('Digite no mínimo 4 caracteres para buscar.');
                  setShowToast(true);
                }
              }
            }}
          ></IonInput>
        </div>

        {/* Lista de sugestões do Google Places */}
        {listaEnderecosGoogle?.length > 0 && (
          <div className="input" style={{ padding: '0' }}>
            <div style={{
              width: '100%',
              border: '1px solid #ddd',
              borderRadius: '8px',
              backgroundColor: '#fff',
              maxHeight: '200px',
              overflowY: 'auto',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              {listaEnderecosGoogle.map((item: any, index: any) => (
                <div
                  key={"sugestao" + index}
                  style={{
                    padding: '12px',
                    borderBottom: index < listaEnderecosGoogle.length - 1 ? '1px solid #eee' : 'none',
                    cursor: 'pointer',
                    backgroundColor: '#fff'
                  }}
                  onClick={() => handleSelectItemEndereco(item)}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                >
                  <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '4px', color: '#333' }}>
                    {item.descricaoPrincipal}
                  </div>
                  {item.descricaoSecundaria && (
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      {item.descricaoSecundaria}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="input">
          <span><b>Dados da conta</b></span>
        </div>
        <div className="input">
          <span>Nome*</span>
          <IonInput value={nome} autoCorrect='true' autoCapitalize='true' maxlength={50} placeholder="" onIonInput={(e: any) => setNome(e.target.value)}></IonInput>
        </div>
        <div className="input">
          <span>CPF*</span>
          <IonInput type="tel" maxlength={14} placeholder="___.___.___-__" required value={cpf} onKeyUp={onChangeCPF} />
        </div>
        <div className="input">
          <span>Telefone*</span>
          <IonInput ref={(ref) => campoTelefone.current = ref} type="tel" maxlength={15} placeholder="(__) _____-____" required value={telefone} onIonInput={onInputTelefone} />
        </div>
        <div className="input">
          <span>E-mail*</span>
          <IonInput value={email} autoCorrect='true' maxlength={50} type="email" placeholder="" onIonInput={(e: any) => setEmail(e.target.value)}></IonInput>
        </div>




        {/* <div className="input">
          <span> Data de Nascimento</span>
          <IonInput value={dataAniversarioBr} placeholder="Selecione" onClick={e => { openPopoverCad(e); }}></IonInput>
        </div> */}

        <div className="input">
          <span>Convite</span>
          <IonInput
            value={convite}
            maxlength={50}
            placeholder=""
            onIonInput={(e: any) => setConvite(e.target.value)}
            disabled={roletaResultado !== "" || Boolean(new URLSearchParams(window.location.search).get('convite'))}
          />
        </div>

        <div className="input">
          <span>Você trabalha com o que?*</span>
        </div>


        <div className="input">

          <IonRadioGroup value={selectedSegment} onIonChange={handleSegmentChange}>
            {segments.map(segment => (
              <IonItem lines='none' key={segment} className="radio-item">
                <IonLabel>{segment}</IonLabel>
                <IonRadio slot="start" value={segment} />
              </IonItem>
            ))}
          </IonRadioGroup>
        </div>



        <div className="input">
          <span>Em qual área você trabalha?*</span>
        </div>


        <div className="input">

          <IonRadioGroup value={selectedArea} onIonChange={handleAreaChange}>
            {Object.entries(specialties).map(([area, specialtiesArray]) => (
              <IonItem lines='none' key={area} className="radio-item">
                <IonLabel>{area}</IonLabel>
                <IonRadio slot="start" value={area} />
              </IonItem>
            ))}
          </IonRadioGroup>
        </div>


        <div className="input" hidden={!selectedArea}>
          <span>Qual sua especialidade?* (Selecione até 3 especialidades)</span>
        </div>

        <div className="input">
          {selectedArea && (
            <IonList>
              {selectedArea && specialties[selectedArea as keyof typeof specialties]?.map((specialty: string) => (
                <IonItem lines='none' key={specialty}>
                  <IonCheckbox
                    checked={selectedSpecialties.includes(specialty)}
                    onIonChange={() => handleSpecialtyChange(specialty)}
                  />
                  <IonLabel>{specialty}</IonLabel>

                </IonItem>
              ))}
            </IonList>
          )}
        </div>

        <div className="input" style={{ display: 'block', alignItems: 'center', paddingTop: '30px' }}>
          <IonCheckbox style={{ 'margin-right': '8px' }} checked={checked} onIonChange={e => setChecked(e.detail.checked)} />
          Eu li e aceito os&nbsp;<a style={{ "color": "red" }} target='_blank' href={'https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/termos/prestador/Termos_de_uso.pdf'}>Termos de Uso <IonIcon src={openOutline} /></a>&nbsp;e&nbsp;<a style={{ "color": "red" }} target='_blank' href={'https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/termos/prestador/politica_de_privacidade.pdf'}>Política de Privacidade <IonIcon src={openOutline} /></a>
        </div>


        <IonButton onClick={cadastrar}>Cadastrar</IonButton>

        {/* <IonPopover ref={popover1}
          isOpen={showModalDataCad}
          onDidDismiss={() => setShowModalDataCad(false)} >
          <IonContent>
            <IonDatetime

              presentation='date'

              onIonChange={e => {

                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAniversarioBr(dataFormatada);
                  setDataAniversario(data);
                }
              }}></IonDatetime>
          </IonContent>
        </IonPopover > */}


        {/* ✅ Modal com a nova roleta */}
        <IonModal isOpen={showRouletteModal} backdropDismiss={false} className="modal-roleta">
          <div className="modal-roleta-container">
            <button
              className="modal-close-btn"
              onClick={() => {
                if (!roletaResultado) {
                  mostartAlerta({
                    header: 'Atenção!',
                    message: 'Tem certeza que vai perder essa oportunidade de desconto?',
                    buttons: [
                      {
                        text: 'Cancelar',
                        role: 'cancel',
                        cssClass: 'secondary'
                      },
                      {
                        text: 'Sim, não quero desconto',
                        handler: () => {
                          setShowRouletteModal(false);
                        }
                      }
                    ]
                  });
                } else {
                  const desconto = roletaResultado.replace('%', '');
                  setConvite(`ROLETA${desconto}`);
                  setShowRouletteModal(false);
                }
              }}
            >
              ×
            </button>

            <div className="modal-image-section">
              {/* Área da roleta ocupando a parte superior */}
              <div className="modal-roleta-area">
                <RoletaDescontos onResult={(resultado) => setRoletaResultado(resultado)} />
              </div>

              {/* Card de oferta na parte inferior */}
              <div className="modal-roleta-card">
                <h2 className="modal-roleta-title">
                  Oferta Especial!
                </h2>
                <p className="modal-roleta-description">
                  Gire e ganhe desconto em todas as mensalidades!
                </p>
                <button
                  className="modal-cta-button"
                  onClick={() => {
                    if (roletaResultado) {
                      const desconto = roletaResultado.replace('%', '');
                      setConvite(`ROLETA${desconto}`);
                      setShowRouletteModal(false);
                    } else {
                      // Mostra alerta se não girou a roleta
                      mostartAlerta({
                        header: 'Atenção!',
                        message: 'Tem certeza que vai perder essa oportunidade de desconto?',
                        buttons: [
                          {
                            text: 'Cancelar',
                            role: 'cancel',
                            cssClass: 'secondary'
                          },
                          {
                            text: 'Sim, não quero desconto',
                            handler: () => {
                              setConvite("");
                              setShowRouletteModal(false);
                            }
                          }
                        ]
                      });
                    }
                  }}
                >
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </IonModal>

        <IonModal isOpen={(Array.isArray(listaEnderecos) && listaEnderecos.length > 0)} onDidDismiss={() => { setListaEnderecos([]); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Selecione um endereço</IonTitle>
              <IonButtons slot="start" onClick={() => setListaEnderecos([])}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListaEnderecos()}
            </IonList>
          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {

              mostartAlerta({
                backdropDismiss: false,
                header: 'Número e complemento',
                message: 'Adicione Número e complemento',
                inputs: [
                  {
                    name: 'mensagem',
                    type: 'textarea',
                    id: 'name2-id',
                    placeholder: 'Digite aqui o número e complemento',
                  }],
                buttons: ['Cancel', {
                  text: 'OK', handler: (d) => {
                    setEndereco(localEnderecoSelecionado + ", " + d.mensagem);
                  }
                }],
                onDidDismiss: (e) => { console.log('did dismiss'); }
              })

              setListaEnderecos([]);
            }}>Avançar</IonButton>
          </IonFooter>
        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={5000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>
    </IonPage>
  );
};

export default CadastroCnpj;
